import { render } from "./TutorSignUpProcess.vue?vue&type=template&id=8fd654f0&scoped=true"
import script from "./TutorSignUpProcess.vue?vue&type=script&lang=js"
export * from "./TutorSignUpProcess.vue?vue&type=script&lang=js"

import "./TutorSignUpProcess.vue?vue&type=style&index=0&id=8fd654f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd654f0"]])

export default __exports__